<template>
  <div>
    <el-form
      ref="form" :model="form" :rules="rules"
      label-position="top"
      size="small"
    >
      <el-form-item :label="$t('basicData.CopyModule')" prop="model">
        <el-select
          v-model="form.model"
          :placeholder="$t('GlobalSetObj.pleaseChoose')"
          style="width: 100%"
        >
          <el-option :label="$t('basicData.BasicRules')" value="1" />
          <el-option :label="$t('basicData.otherRules')" value="2" />
        </el-select>
      </el-form-item>
    </el-form>
    <div class="btn-group">
      <el-button size="small" type="primary" @click="submit">{{ $t('GlobalSetObj.confirm') }}</el-button>
      <el-button size="small" @click="cancel">{{ $t('GlobalSetObj.cancel') }}</el-button>
    </div>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash-es';
export default {
  data() {
    return {
      rules: {
        model: [
          { required: true, message: this.$t('GlobalSetObj.pleaseChoose'), trigger: ['blur', 'change'] }
        ]
      },
      form: {
        model: ''
      }
    };
  },
  methods: {
    submit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          const params = cloneDeep(this.form);
          this.$emit('submit', params);
          this.cancel();
        }
      });
    },
    cancel() {
      this.$emit('close');
      this.reset();
    },
    reset() {
      this.$refs.form.resetFields();
    }
  }
};
</script>

<style lang="scss" scoped>
.btn-group {
  text-align: right;
}
</style>
